import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ViewCardComponent, ViewCardConfig } from '@ep/shared';
import { Observable, tap } from 'rxjs';
import { ApplicationProfile, PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';
@Component({
  selector: 'app-dashboard-loyalty-program-panel',
  templateUrl: './dashboard-loyalty-program-panel.component.html',
  styleUrls: ['./dashboard-loyalty-program-panel.component.scss'],
  standalone: true,
  imports: [DividerModule, NgForOf, NgIf, AsyncPipe, ViewCardComponent],
})
export class DashboardLoyaltyProgramPanelComponent implements OnInit {
  @Input() data$!: Observable<ViewCardConfig[]>;

  private readonly applicationProfileService = inject(ApplicationProfileService);
  private readonly cssValidatorService = inject(CssValidatorService);
  applicationProfile!: ApplicationProfile;
  protected theme!: PortalTheme;

  private readonly cdr = inject(ChangeDetectorRef);
  protected configs: ViewCardConfig[] = [];

  ngOnInit() {
    this.data$.subscribe((data) => {
      this.configs = data;
      this.cdr.detectChanges();

      this.applicationProfileService.applicationProfile$
        .pipe(
          tap((appProfile: ApplicationProfile) => {
            this.applicationProfile = appProfile;
            this.theme = appProfile.PortalTheme.Theme;
            this.setCSSCustomProperties();
            this.checkTheme(data);
          })
        )
        .subscribe();
    });
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties based on the theme
      document.documentElement.style.setProperty('--dashboard-text--color', this.theme.dashboard.coloredCardTextColor);
      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('DashboardLoyaltyProgramPanelComponent');
    }
  }

  private checkTheme(data: Array<ViewCardConfig>) {
    const colorMap: Record<string, string> = {
      SALES: this.theme.dashboard.sales,
      LOYALTY: this.theme.dashboard.loyalty,
      REWARDS: this.theme.dashboard.rewards,
      REVIEWS: this.theme.dashboard.reviews,
    };

    data.forEach((item) => {
      if (item.subheader && colorMap[item.subheader]) {
        item.backgroundColor = colorMap[item.subheader];
      }
    });
  }
}
